import React from 'react';
import { ButtonGroup as BaseButtonGroup, Grid } from '@material-ui/core';
import styled from 'styled-components';
const ButtonGroup = styled(BaseButtonGroup).withConfig({
  displayName: "UtilityBar__ButtonGroup",
  componentId: "sc-1ct6bsd-0"
})(["&&.MuiButtonGroup-root{max-height:fill-available;}"]);
const UtilityBarWrap = styled(Grid).withConfig({
  displayName: "UtilityBar__UtilityBarWrap",
  componentId: "sc-1ct6bsd-1"
})(["padding:0 4px;", ";"], props => props['data-maxheight'] ? `max-height: ${props['data-maxheight']}px` : '');
export const UtilityBar = ({
  style,
  maxHeight,
  children
}) => /*#__PURE__*/React.createElement(UtilityBarWrap, {
  "data-testid": "UB-wrap",
  style: style,
  "data-maxheight": maxHeight
}, /*#__PURE__*/React.createElement(ButtonGroup, {
  variant: "text",
  color: "primary",
  size: "small"
}, children));
export default UtilityBar;